import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/internal/Observable';
import {BaseStoreService} from '@core/abstract/store.abstract';
import {IActiveHolidayResolved} from '@core/model/HTTP/Resolver/store';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {IHoliday} from '@core/model';
import {isPlatformBrowser} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class ActiveHolidayResolver implements Resolve<IActiveHolidayResolved> {

  constructor(private baseStoreService: BaseStoreService, @Inject(PLATFORM_ID) private platformId: object) {

  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IActiveHolidayResolved> {
    if (!isPlatformBrowser(this.platformId))
      return of({
        holiday: null,
        error: 'Not a browser'
      });


    return this.baseStoreService.getActiveHoliday().pipe(
      map((holiday: IHoliday) => ({holiday} as IActiveHolidayResolved)),
      catchError(err => {
        return of({
          holiday: null,
          error: err
        } as IActiveHolidayResolved);
      })
    );
  }
}
